<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0 d-flex align-items-center">
            <h6 class="mb-0">Detalle del Pedido </h6>
            <div class="ms-auto d-flex align-items-center gap-2">
              
              <button
                v-if="order && lineItems.length"
                class="btn btn-primary btn-sm"
                @click="startPicking"
              >
                <i class="fas fa-box-open me-1"></i> Picking Packing
              </button>
              <button
                v-if="order && isOrderPrepared && !hasWaybill && !isVeOrder"
                class="btn btn-success btn-sm"
                @click="openShippingModal"
              >
                <i class="fas fa-truck me-1"></i> Generar ticket de envío
              </button>
              <button
                v-if="order && isOrderPrepared && !isOrderDispatched"
                class="btn btn-warning btn-sm"
                :disabled="isMarkingDispatched"
                @click="markAsDispatched"
              >
                <i class="fas fa-spinner fa-spin me-1" v-if="isMarkingDispatched"></i>
                <i class="fas fa-check-circle me-1" v-else></i>
                Marcar como despachado
              </button>
              <button
                v-if="order && hasWaybill && !isVeOrder"
                class="btn btn-info btn-sm"
                @click="printWaybill"
                :disabled="isPrintingWaybill"
              >
                <i class="fas fa-print me-1" v-if="!isPrintingWaybill"></i>
                <i class="fas fa-spinner fa-spin me-1" v-if="isPrintingWaybill"></i>
                Imprimir rótulo
              </button>
              <button
                v-if="order && isVeOrder"
                class="btn btn-sm"
                :class="order.kubapp_invoiced_at ? 'btn-outline-success' : 'btn-success'"
                :disabled="isMarkingInvoiced"
                @click="toggleInvoiced"
                :title="order.kubapp_invoiced_at
                  ? `Facturado el ${formatDate(order.kubapp_invoiced_at)}. Clic para quitar la marca`
                  : 'Marcar como facturado'"
              >
                <i class="fas fa-spinner fa-spin me-1" v-if="isMarkingInvoiced"></i>
                <i class="fas fa-file-invoice me-1" v-else></i>
                {{ order.kubapp_invoiced_at ? 'Facturado' : 'Marcar facturado' }}
              </button>
              <button class="btn btn-link btn-sm p-0 text-secondary" @click="goBack">
                <i class="fas fa-arrow-left me-1"></i> Volver
              </button>
            </div>
          </div>
          <div class="card-body">
            <div v-if="isLoading" class="text-center py-4">
              <i class="fas fa-spinner fa-spin me-1"></i> Cargando...
            </div>
            <div v-else-if="!order" class="text-center py-4 text-muted">
              No se encontró el pedido.
            </div>
            <div v-else>
              <div class="row mb-4">
                <div class="col-md-6">
                  <h6 class="text-uppercase text-secondary text-xxs font-weight-bolder mb-2">Información del pedido</h6>
                  <table class="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td class="text-secondary text-xs" style="width: 140px">Orden</td>
                        <td class="text-sm font-weight-bold">{{ orderLabel(order) }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Origen</td>
                        <td class="text-sm">{{ order.source === 'shopify' ? 'Shopify' : (order.source === 'shopify-ve' ? 'Shopify Vzla' : 'POS') }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Estado financiero</td>
                        <td class="text-sm">{{ order.financial_status || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Estado envío</td>
                        <td class="text-sm">{{ order.fulfillment_status || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Método de pago</td>
                        <td class="text-sm">{{ order.payment_method || '—' }}</td>
                      </tr>
                      <tr v-if="isVeOrder">
                        <td class="text-secondary text-xs">Factura Kubapp</td>
                        <td class="text-sm">
                          <span
                            v-if="order.kubapp_invoiced_at"
                            class="badge badge-sm bg-gradient-success"
                            :title="formatDate(order.kubapp_invoiced_at)"
                          >
                            <i class="fas fa-check me-1"></i>Facturado el {{ formatDate(order.kubapp_invoiced_at) }}
                          </span>
                          <span v-else class="text-secondary">—</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Moneda</td>
                        <td class="text-sm">{{ order.currency || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Fecha</td>
                        <td class="text-sm">{{ formatDate(order.shopify_created_at || order.synced_at || order.created_at) }}</td>
                      </tr>
                      <tr v-if="order.note">
                        <td class="text-secondary text-xs">Nota</td>
                        <td class="text-sm">{{ order.note }}</td>
                      </tr>
                      <tr v-if="order.tags">
                        <td class="text-secondary text-xs">Etiquetas</td>
                        <td class="text-sm">{{ order.tags }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-md-6">
                  <div class="d-flex align-items-center mb-2">
                    <h6 class="text-uppercase text-secondary text-xxs font-weight-bolder mb-0">Cliente</h6>
                    <button
                      v-if="!isVeOrder"
                      class="btn btn-sm p-2 m-0 ms-2 text-secondary"
                      @click="openCustomerEditModal"
                      title="Editar cliente"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                  </div>
                  <table class="table table-sm table-borderless">
                    <tbody>
                      <tr>
                        <td class="text-secondary text-xs" style="width: 140px">Nombre</td>
                        <td class="text-sm font-weight-bold">{{ order.customer_name || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Email</td>
                        <td class="text-sm">{{ order.email || '—' }}</td>
                      </tr>
                      <tr v-if="order.customer && order.customer.phone">
                        <td class="text-secondary text-xs">Teléfono</td>
                        <td class="text-sm">{{ order.customer.phone }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="d-flex align-items-center mb-2 mt-3">
                    <h6 class="text-uppercase text-secondary text-xxs font-weight-bolder mb-0">Dirección de envío</h6>
                    <button
                      v-if="order.shipping_address && !isVeOrder"
                      class="btn btn-sm p-2 m-0 ms-2 text-secondary"
                      @click="openAddressEditModal"
                      title="Editar dirección"
                    >
                      <i class="fas fa-pencil-alt"></i>
                    </button>
                  </div>
                  <table class="table table-sm table-borderless" v-if="order.shipping_address">
                    <tbody>
                      <tr>
                        <td class="text-secondary text-xs" style="width: 140px">Nombre</td>
                        <td class="text-sm">{{ [order.shipping_address.first_name, order.shipping_address.last_name].filter(Boolean).join(' ') || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Dirección</td>
                        <td class="text-sm">{{ order.shipping_address.address1 || '—' }}</td>
                      </tr>
                      <tr v-if="order.shipping_address.address2">
                        <td class="text-secondary text-xs">Dirección 2</td>
                        <td class="text-sm">{{ order.shipping_address.address2 }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Ciudad</td>
                        <td class="text-sm">{{ order.shipping_address.city || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Provincia</td>
                        <td class="text-sm">{{ order.shipping_address.province || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">País</td>
                        <td class="text-sm">{{ order.shipping_address.country || '—' }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Código postal</td>
                        <td class="text-sm">{{ order.shipping_address.zip || '—' }}</td>
                      </tr>
                      <tr v-if="order.shipping_address.phone">
                        <td class="text-secondary text-xs">Teléfono</td>
                        <td class="text-sm">{{ order.shipping_address.phone }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <p v-else class="text-sm text-muted">Sin dirección de envío</p>
                </div>
              </div>

              <div class="d-flex align-items-center mb-2">
                <h6 class="text-uppercase text-secondary text-xxs font-weight-bolder mb-0">Productos</h6>
                <button
                  v-if="isVeOrder && hasVenezuelaItems"
                  class="btn mb-0 btn-outline-secondary btn-sm ms-auto"
                  type="button"
                  @click="copyVeItemsForExcel"
                  title="Copiar ítems VZL para crear la factura en Kubapp Venezuela"
                >
                  <i class="fas fa-copy me-1" aria-hidden="true"></i>Sinc Venezuela
                </button>
                <button
                  v-if="isVeOrder && hasColombiaItems"
                  class="btn mb-0 btn-sm ms-2"
                  :class="order?.kubapp_invoiced_at ? 'btn-outline-success' : 'btn-outline-secondary'"
                  type="button"
                  :disabled="isSyncingKubapp"
                  @click="syncOrderToKubapp"
                  :title="order?.kubapp_invoiced_at
                    ? `Factura registrada el ${formatDate(order.kubapp_invoiced_at)}. Volver a sincronizar con Kubapp Colombia`
                    : 'Sincronizar factura de venta con Kubapp Colombia'"
                >
                  <i class="fas fa-sync-alt me-1" :class="{ 'fa-spin': isSyncingKubapp }" aria-hidden="true"></i>Sincronizar con Kubapp Colombia
                </button>
              </div>
              <div class="table-responsive">
                <table class="table align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producto</th>
                      <th v-if="isVeOrder" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Origen</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad</th>
                      <th v-if="isVeOrder" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Costo</th>
                      <th v-if="isVeOrder" class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio COP</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Precio</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total</th>
                      <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, idx) in lineItems" :key="idx">
                      <td>
                        <span class="text-sm font-weight-bold d-block">{{ item.title || item.name || '—' }}</span>
                        <span v-if="item.variant_title" class="text-xs text-secondary">{{ item.variant_title }}</span>
                        <span v-if="item.sku" class="text-xs text-secondary d-block">SKU: {{ item.sku }}</span>
                      </td>
                      <td v-if="isVeOrder" class="text-center">
                        <span
                          v-if="item.origin"
                          class="badge"
                          :class="item.origin === 'COP' ? 'bg-info' : 'bg-danger'"
                        >
                          {{ item.origin }}
                        </span>
                        <span v-else class="text-xs text-secondary">—</span>
                      </td>
                      <td class="text-center text-sm">{{ item.quantity || 1 }}</td>
                      <td v-if="isVeOrder" class="text-center text-sm">{{ item.cost != null ? formatNumber(item.cost) : '—' }}</td>
                      <td v-if="isVeOrder" class="text-center text-sm">{{ itemPriceCop(item) }}</td>
                      <td class="text-center text-sm">{{ formatMoney(itemPrice(item), order.currency) }}</td>
                      <td class="text-center text-sm">{{ formatMoney(itemTotal(item), order.currency) }}</td>
                      <td class="text-center">
                        <span
                          class="badge"
                          :class="getItemPickingStatus(item) === 'picked' ? 'bg-success' : 'bg-warning text-dark'"
                        >
                          {{ getItemPickingStatus(item) === 'picked' ? 'Preparado' : 'Pendiente' }}
                        </span>
                      </td>
                    </tr>
                    <tr v-if="!lineItems.length">
                      <td :colspan="isVeOrder ? 8 : 5" class="text-center text-muted text-xs">Sin productos</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="row mt-4">
                <div class="col-md-6 offset-md-6">
                  <table class="table table-sm">
                    <tbody>
                      <tr>
                        <td class="text-secondary text-xs">Subtotal</td>
                        <td class="text-sm text-end">{{ formatMoney(order.subtotal_price, order.currency) }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Impuestos</td>
                        <td class="text-sm text-end">{{ formatMoney(order.total_tax, order.currency) }}</td>
                      </tr>
                      <tr>
                        <td class="text-secondary text-xs">Descuentos</td>
                        <td class="text-sm text-end">{{ formatMoney(order.total_discounts, order.currency) }}</td>
                      </tr>
                      <tr>
                        <td class="text-sm font-weight-bold">Total</td>
                        <td class="text-sm font-weight-bold text-end">{{ formatMoney(order.total_price, order.currency) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Picking Packing -->
    <div v-if="showPickingModal" class="picking-modal-overlay">
      <div class="picking-modal-box" style="max-width: 820px; max-height: 92vh;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-barcode me-2"></i>
            Picking Packing
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closePickingModal">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="picking-modal-body">
          <p class="text-xs text-secondary mb-3">
            Escanea el código de barras (SKU) de cada producto para marcarlo como preparado.
          </p>

          <div class="picking-scan-input-wrapper">
            <input
              ref="scanInput"
              v-model="scanValue"
              type="text"
              class="form-control picking-scan-input"
              placeholder="Escanear o digitar SKU..."
              @keyup.enter="handleScan"
              @input="onScanInput"
              :disabled="isScanning"
            />
            <button
              class="btn btn-primary picking-scan-btn"
              @click="handleScan"
              :disabled="isScanning || !scanValue.trim()"
            >
              <i class="fas fa-check" v-if="!isScanning"></i>
              <i class="fas fa-spinner fa-spin" v-else></i>
            </button>
          </div>

          <div v-if="scanMessage" class="picking-scan-message" :class="scanMessageType">
            <i :class="scanMessageType === 'success' ? 'fas fa-check-circle' : 'fas fa-exclamation-circle'"></i>
            {{ scanMessage }}
          </div>

          <div class="picking-progress mt-3">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <span class="text-xs text-secondary font-weight-bold">Progreso</span>
              <span class="text-xs font-weight-bold">{{ pickedCount }} / {{ pickingItems.length }}</span>
            </div>
            <div class="progress" style="height: 6px;">
              <div
                class="progress-bar bg-success"
                :style="{ width: pickingProgress + '%' }"
              ></div>
            </div>
          </div>

          <div class="picking-items-list mt-3">
            <div
              v-for="item in sortedPickingItems"
              :key="item.id"
              class="picking-item-row"
              :class="{ 'picking-item-picked': item.status === 'picked' }"
            >
              <div class="d-flex align-items-center">
                <i
                  :class="item.status === 'picked' ? 'fas fa-check-circle text-success' : 'fas fa-clock text-warning'"
                  class="me-2"
                ></i>
                <div>
                  <span class="text-sm font-weight-bold d-block">{{ item.title || '—' }}</span>
                  <span v-if="getVariantTitle(item)" class="text-xs text-secondary d-block">{{ getVariantTitle(item) }}</span>
                  <span class="text-xs text-secondary">SKU: {{ item.sku || '—' }} · Cant: {{ item.quantity }}</span>
                </div>
              </div>
              <div class="d-flex align-items-center" style="gap: 6px;">
                <button
                  type="button"
                  class="btn btn-outline-success btn-sm mb-0 mx-1"
                  :class="{ 'btn-success': item.status === 'picked' }"
                  @click="togglePickingItem(item)"
                  :disabled="item.toggling || item.status === 'picked'"
                  :title="item.status === 'picked' ? 'Preparado' : 'Marcar como preparado'"
                >
                  <i :class="item.toggling ? 'fas fa-spinner fa-spin' : 'fas fa-check'"></i>
                </button>
              </div>
            </div>
            <div v-if="!pickingItems.length" class="text-center text-muted text-xs py-3">
              No hay items para picking.
            </div>
          </div>
        </div>

        <div class="picking-modal-footer">
          <button
            v-if="pickedCount === pickingItems.length && pickingItems.length > 0"
            class="btn btn-success btn-sm w-100"
            @click="completePicking"
            :disabled="isCompletingPicking"
          >
            <i class="fas fa-spinner fa-spin me-1" v-if="isCompletingPicking"></i>
            <i class="fas fa-check me-1" v-else></i> Picking completado
          </button>
          <div v-else class="d-flex align-items-center justify-content-between" style="gap: 8px;">
            <button
              class="btn btn-outline-success btn-sm mb-0"
              @click="markAllPicked"
              :disabled="isMarkingAllPicked || pendingPickingItems.length === 0"
              :title="pendingPickingItems.length === 0 ? 'No hay items pendientes' : 'Marcar todos los productos como preparados'"
            >
              <i class="fas fa-spinner fa-spin me-1" v-if="isMarkingAllPicked"></i>
              <i class="fas fa-check-double me-1" v-else></i>
              Marcar todos
            </button>
            <button class="btn btn-outline-secondary btn-sm mb-0" @click="closePickingModal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Shipping -->
    <div v-if="showShippingModal" class="picking-modal-overlay">
      <div class="picking-modal-box" style="max-width: 880px;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-truck me-2"></i>
            Generar ticket de envío
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closeShippingModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="picking-modal-body">
          <div v-if="shippingError" class="picking-scan-message error mb-3">
            <i class="fas fa-exclamation-circle"></i>
            {{ shippingError }}
          </div>

          <div class="row g-2 mb-3">
            <div class="col-md-6">
              <div class="border rounded p-3 h-100 bg-light">
                <div class="text-xs text-uppercase text-secondary font-weight-bolder mb-3">
                  <i class="fas fa-map-marker-alt me-1"></i> Ubicación del cliente
                </div>
                <div class="text-xs location-info-row"><strong>Nombre:</strong> {{ shippingCustomerName }}</div>
                <div class="text-xs location-info-row"><strong>Dirección:</strong> {{ order?.shipping_address?.address1 || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Ciudad:</strong> {{ order?.shipping_address?.city || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Departamento:</strong> {{ order?.shipping_address?.province || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Código postal:</strong> {{ order?.shipping_address?.zip || '—' }}</div>
                <div class="text-xs location-info-row"><strong>Teléfono:</strong> {{ order?.shipping_address?.phone || '—' }}</div>
                <div class="text-xs location-info-row mb-0"><strong>Email:</strong> {{ order?.email || '—' }}</div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="border rounded p-2 h-100">
                <div class="text-xs text-uppercase text-secondary font-weight-bolder mb-2">
                  <i class="fas fa-calculator me-1"></i> Datos del cálculo de envío
                </div>
                <label class="text-xs text-secondary mb-0">Dirección</label>
                <input v-model="shippingForm.address" class="form-control form-control-sm mb-1" placeholder="Dirección de envío" />
                <div class="row g-1">
                  <div class="col-6">
                    <label class="text-xs text-secondary mb-0">Ciudad</label>
                    <select v-model="shippingForm.city" class="form-select form-select-sm mb-1">
                      <option value="" disabled>Seleccione...</option>
                      <option v-if="cityNotInList" :value="shippingForm.city">{{ shippingForm.city }} (no está en la lista)</option>
                      <option v-for="c in shippingCities" :key="c" :value="c">{{ c }}</option>
                    </select>
                  </div>
                  <div class="col-6">
                    <label class="text-xs text-secondary mb-0">Departamento</label>
                    <select v-model="shippingForm.province" @change="onShippingProvinceChange" class="form-select form-select-sm mb-1">
                      <option value="" disabled>Seleccione...</option>
                      <option v-if="provinceNotInList" :value="shippingForm.province">{{ shippingForm.province }} (no está en la lista)</option>
                      <option v-for="d in shippingDepartments" :key="d" :value="d">{{ d }}</option>
                    </select>
                  </div>
                </div>
                <div class="row g-1">
                  <div class="col-4">
                    <label class="text-xs text-secondary mb-0">Código postal</label>
                    <input v-model="shippingForm.zip" class="form-control form-control-sm mb-1" placeholder="ZIP" />
                  </div>
                  <div class="col-4">
                    <label class="text-xs text-secondary mb-0">Teléfono</label>
                    <input v-model="shippingForm.phone" class="form-control form-control-sm mb-1" placeholder="Teléfono" />
                  </div>
                  <div class="col-4">
                    <label class="text-xs text-secondary mb-0">Cédula/NIT</label>
                    <input v-model="shippingForm.company" class="form-control form-control-sm mb-1" placeholder="Cédula/NIT" />
                  </div>
                </div>
                <button
                  class="btn btn-primary btn-sm w-100 mt-2"
                  type="button"
                  @click="recalculateShipping"
                  :disabled="isCalculatingShipping"
                >
                  <i class="fas fa-sync-alt me-1" :class="{ 'fa-spin': isCalculatingShipping }"></i>
                  Recalcular
                </button>
              </div>
            </div>
          </div>

          <div v-if="isCalculatingShipping" class="text-center py-4">
            <i class="fas fa-spinner fa-spin me-1"></i> Calculando opciones de envío...
          </div>

          <div v-else-if="shippingOptions.length">
            <h6 class="text-uppercase text-secondary text-xxs font-weight-bolder mb-2">Opciones de envío</h6>
            <div
              v-for="(opt, idx) in shippingOptions"
              :key="idx"
              class="shipping-option-row"
              :class="{ 'shipping-option-selected': selectedShippingOption === idx }"
              @click="selectedShippingOption = idx"
            >
              <div class="d-flex align-items-center" style="flex:1; min-width:0;">
                <img
                  v-if="opt.carrier_image"
                  :src="opt.carrier_image"
                  :alt="opt.carrier_name"
                  style="width: 32px; height: 32px; object-fit: contain; margin-right: 8px;"
                />
                <i v-else class="fas fa-shipping-fast me-2 text-primary"></i>
                <div style="min-width:0;">
                  <span class="text-sm font-weight-bold d-block">{{ opt.carrier_name || opt.shipping_method || ('Opción ' + (idx + 1)) }}</span>
                  <span class="text-xs text-secondary d-block">
                    {{ opt.delivery_days ? opt.delivery_days + ' día(s)' : (opt.delivery_time || opt.eta || '—') }}
                    <span v-if="opt.shipping_method" class="text-muted">— {{ opt.shipping_method }}</span>
                  </span>
                </div>
              </div>
              <div class="text-end ms-2" style="white-space:nowrap;">
                <span class="text-sm font-weight-bold d-block">{{ formatMoney(opt.price || opt.total || 0, 'COP') }}</span>
                <button class="btn btn-link btn-xs p-0 text-xs" @click.stop="showRawResponse = !showRawResponse">
                  Ver JSON
                </button>
              </div>
            </div>

            <div v-if="showRawResponse" class="mt-2 p-2 bg-light rounded">
              <pre class="text-xs mb-0" style="max-height:200px; overflow:auto;">{{ JSON.stringify(shippingOptions, null, 2) }}</pre>
            </div>

            <div class="mt-3">
              <label class="text-xs text-secondary font-weight-bold">Método de pago</label>
              <select v-model="shippingPaymentMethod" class="form-control form-control-sm mt-1">
                <option value="">Flete pago</option>
                <option value="Contraentrega">Contraentrega + Flete</option>
                <option value="Flete Contraentrega">Flete Contraentrega</option>
              </select>
            </div>

            <div class="d-flex align-items-center mt-2">
              <input type="checkbox" id="chargeShipping" v-model="chargeShippingToCustomer" style="margin-right: 6px;" />
              <label class="text-xs" for="chargeShipping" style="margin-bottom: 0;">Cobrar envío al cliente</label>
            </div>
          </div>

          <div v-else-if="!isCalculatingShipping && hasCalculatedShipping" class="text-center text-muted text-xs py-3">
            No se encontraron opciones de envío.
          </div>
        </div>
        <div class="picking-modal-footer">
          <button
            v-if="shippingOptions.length && selectedShippingOption !== null"
            class="btn btn-success btn-sm w-100"
            @click="generateTicket"
            :disabled="isGeneratingWaybill"
          >
            <i class="fas fa-spinner fa-spin me-1" v-if="isGeneratingWaybill"></i>
            <i class="fas fa-ticket-alt me-1" v-else></i>
            Generar guía de envío
          </button>
          <button v-else class="btn btn-link btn-sm text-secondary w-100" @click="closeShippingModal">
            Cerrar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal editar cliente -->
    <div v-if="showCustomerEditModal" class="picking-modal-overlay" @click.self="closeCustomerEditModal">
      <div class="picking-modal-box" style="max-width: 500px;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-pencil-alt me-2"></i>
            Editar cliente
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closeCustomerEditModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="picking-modal-body">
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Nombre</label>
            <input v-model="customerEditForm.customer_name" type="text" class="form-control form-control-sm" />
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Email</label>
            <input v-model="customerEditForm.email" type="text" class="form-control form-control-sm" />
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Teléfono</label>
            <input v-model="customerEditForm.phone" type="text" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="picking-modal-footer">
          <button class="btn btn-secondary btn-sm" @click="closeCustomerEditModal">Cancelar</button>
          <button
            class="btn btn-primary btn-sm"
            @click="saveCustomer"
            :disabled="isSavingCustomer"
          >
            <i v-if="isSavingCustomer" class="fas fa-spinner fa-spin me-1"></i>
            <i v-else class="fas fa-save me-1"></i>
            Guardar
          </button>
        </div>
      </div>
    </div>

    <!-- Modal editar dirección -->
    <div v-if="showAddressEditModal" class="picking-modal-overlay" @click.self="closeAddressEditModal">
      <div class="picking-modal-box" style="max-width: 500px;">
        <div class="picking-modal-header">
          <h5 class="mb-0">
            <i class="fas fa-pencil-alt me-2"></i>
            Editar dirección de envío
          </h5>
          <button class="btn btn-link btn-sm p-0 text-secondary" @click="closeAddressEditModal">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="picking-modal-body">
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Nombre</label>
              <input v-model="addressEditForm.first_name" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Apellido</label>
              <input v-model="addressEditForm.last_name" type="text" class="form-control form-control-sm" />
            </div>
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Dirección</label>
            <input v-model="addressEditForm.address1" type="text" class="form-control form-control-sm" />
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Dirección 2</label>
            <input v-model="addressEditForm.address2" type="text" class="form-control form-control-sm" />
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Ciudad</label>
              <input v-model="addressEditForm.city" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Provincia</label>
              <input v-model="addressEditForm.province" type="text" class="form-control form-control-sm" />
            </div>
          </div>
          <div class="row">
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">País</label>
              <input v-model="addressEditForm.country" type="text" class="form-control form-control-sm" />
            </div>
            <div class="col-md-6 mb-2">
              <label class="form-label text-xs text-secondary mb-1">Código postal</label>
              <input v-model="addressEditForm.zip" type="text" class="form-control form-control-sm" />
            </div>
          </div>
          <div class="mb-2">
            <label class="form-label text-xs text-secondary mb-1">Teléfono</label>
            <input v-model="addressEditForm.phone" type="text" class="form-control form-control-sm" />
          </div>
        </div>
        <div class="picking-modal-footer">
          <button class="btn btn-secondary btn-sm" @click="closeAddressEditModal">Cancelar</button>
          <button
            class="btn btn-primary btn-sm"
            @click="saveAddress"
            :disabled="isSavingAddress"
          >
            <i v-if="isSavingAddress" class="fas fa-spinner fa-spin me-1"></i>
            <i v-else class="fas fa-save me-1"></i>
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shopifyService from "@/services/shopify.service";
import shopifyVeService from "@/services/shopifyVenezuela.service";
import Swal from "sweetalert2";
import ciudadesData from "@/data/ciudades.json";

// Índice de búsqueda: nombre normalizado -> codigo_dane
// Normaliza: mayúsculas, sin tildes, sin espacios extra, sin paréntesis/depto.
function normalizeCityName(name) {
  if (!name) return "";
  return String(name)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // quita tildes
    .toUpperCase()
    .trim()
    .replace(/\s+/g, " ");
}

const ciudadIndex = (() => {
  const index = new Map();
  for (const c of ciudadesData) {
    if (!c.activo) continue;
    const entry = { dane: c.codigo_dane, dpto: normalizeCityName(c.dpto) };
    // Nombre completo sin el sufijo de departamento entre paréntesis
    const baseName = (c.nombre || "").replace(/\s*\([^)]*\)\s*$/, "").trim();
    const keys = new Set(
      [baseName, c.abreviado, c.nombre].map(normalizeCityName).filter(Boolean)
    );
    for (const norm of keys) {
      if (!index.has(norm)) index.set(norm, []);
      index.get(norm).push(entry);
    }
  }
  return index;
})();

// Códigos ISO de provincia de Shopify -> nombre de departamento usado en ciudades.json
const PROVINCE_CODE_TO_DPTO = {
  AMA: "AMAZONAS", ANT: "ANTIOQUIA", ARA: "ARAUCA", ATL: "ATLANTICO",
  BOL: "BOLIVAR", BOY: "BOYACA", CAL: "CALDAS", CAQ: "CAQUETA",
  CAS: "CASANARE", CAU: "CAUCA", CES: "CESAR", CHO: "CHOCO",
  COR: "CORDOBA", CUN: "CUNDINAMARCA", DC: "CUNDINAMARCA",
  GUA: "GUAINIA", GUV: "GUAVIARE", HUI: "HUILA", LAG: "LA GUAJIRA",
  MAG: "MAGDALENA", MET: "META", NAR: "NARINO", NSA: "NORTE DE SANTANDER",
  PUT: "PUTUMAYO", QUI: "QUINDIO", RIS: "RISARALDA", SAN: "SANTANDER",
  SAP: "SAN ANDRES Y PROVIDENCIA", SUC: "SUCRE", TOL: "TOLIMA",
  VAC: "VALLE", VAU: "VAUPES", VID: "VICHADA",
};

// Puntaje de coincidencia provincia (dirección) vs dpto (ciudades.json)
function deptScore(provinceNorm, dptoNorm) {
  if (!provinceNorm || !dptoNorm) return 0;
  if (provinceNorm === dptoNorm) return 3;
  if (provinceNorm.startsWith(dptoNorm) || dptoNorm.startsWith(provinceNorm)) return 2;
  const re = new RegExp(`(^|\\s)${dptoNorm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}(\\s|$)`);
  if (re.test(provinceNorm)) return 1;
  return 0;
}

// De una lista de ciudades candidatas elige la que coincide con el departamento
function pickByProvince(candidates, provinceNorm) {
  if (!candidates || !candidates.length) return "";
  if (candidates.length === 1 || !provinceNorm) return candidates[0].dane;
  let best = candidates[0];
  let bestScore = 0;
  for (const c of candidates) {
    const score = deptScore(provinceNorm, c.dpto);
    if (score > bestScore) {
      best = c;
      bestScore = score;
    }
  }
  return best.dane;
}

function buscarCodigoDane(cityName, provinceName, provinceCode) {
  if (!cityName) return "";
  const norm = normalizeCityName(cityName);
  if (!norm) return "";
  const dept = normalizeCityName(provinceName) || PROVINCE_CODE_TO_DPTO[(provinceCode || "").toUpperCase()] || "";
  // Búsqueda exacta
  if (ciudadIndex.has(norm)) return pickByProvince(ciudadIndex.get(norm), dept);
  // Búsqueda por prefijo (ej: "BOGOTA D.C." -> "BOGOTA")
  let candidates = [];
  for (const [key, list] of ciudadIndex) {
    if (norm.startsWith(key) || key.startsWith(norm)) candidates.push(...list);
  }
  if (candidates.length) return pickByProvince(candidates, dept);
  // Búsqueda por inclusión de palabra principal
  const firstWord = norm.split(" ")[0];
  if (firstWord) {
    candidates = [];
    for (const [key, list] of ciudadIndex) {
      if (key.split(" ")[0] === firstWord) candidates.push(...list);
    }
    if (candidates.length) return pickByProvince(candidates, dept);
  }
  return "";
}

export default {
  name: "ShopifyOrderDetail",
  data() {
    return {
      order: null,
      isLoading: false,
      showPickingModal: false,
      pickingItems: [],
      scanValue: "",
      scanMessage: "",
      scanMessageType: "",
      isScanning: false,
      scanDebounceTimer: null,
      isCompletingPicking: false,
      isMarkingAllPicked: false,
      showShippingModal: false,
      isCalculatingShipping: false,
      hasCalculatedShipping: false,
      shippingOptions: [],
      shippingError: "",
      selectedShippingOption: null,
      shippingPaymentMethod: "",
      chargeShippingToCustomer: true,
      shippingForm: {
        address: "",
        city: "",
        province: "",
        zip: "",
        phone: "",
        company: "",
      },
      isGeneratingWaybill: false,
      isPrintingWaybill: false,
      isMarkingDispatched: false,
      isSyncingKubapp: false,
      isMarkingInvoiced: false,
      showRawResponse: false,
      showCustomerEditModal: false,
      isSavingCustomer: false,
      customerEditForm: {
        customer_name: "",
        email: "",
        phone: "",
      },
      showAddressEditModal: false,
      isSavingAddress: false,
      addressEditForm: {
        first_name: "",
        last_name: "",
        address1: "",
        address2: "",
        city: "",
        province: "",
        country: "",
        zip: "",
        phone: "",
      },
    };
  },
  computed: {
    shippingCustomerName() {
      const addr = this.order?.shipping_address || {};
      return this.order?.customer_name
        || [addr.first_name, addr.last_name].filter(Boolean).join(' ')
        || '—';
    },
    shippingDepartments() {
      const set = new Set();
      for (const c of ciudadesData) {
        if (c.activo && c.dpto) set.add(c.dpto);
      }
      return [...set].sort((a, b) => a.localeCompare(b, "es"));
    },
    shippingCities() {
      const dept = this.shippingForm.province.trim();
      if (!dept) return [];
      const deptNorm = normalizeCityName(dept);
      const map = new Map();
      for (const c of ciudadesData) {
        if (!c.activo || normalizeCityName(c.dpto || "") !== deptNorm) continue;
        const base = (c.nombre || "").replace(/\s*\([^)]*\)\s*$/, "").trim();
        const name = base || (c.abreviado || "").trim();
        if (name) map.set(normalizeCityName(name), name);
      }
      return [...map.values()].sort((a, b) => a.localeCompare(b, "es"));
    },
    provinceNotInList() {
      const v = this.shippingForm.province.trim();
      if (!v) return false;
      return !this.shippingDepartments.some((d) => normalizeCityName(d) === normalizeCityName(v));
    },
    cityNotInList() {
      const v = this.shippingForm.city.trim();
      if (!v) return false;
      return !this.shippingCities.some((c) => normalizeCityName(c) === normalizeCityName(v));
    },
    lineItems() {
      if (!this.order) return [];
      const items = this.order.line_items;
      if (!Array.isArray(items)) return [];
      if (this.isVeOrder) {
        const originRank = (item) => (item?.origin === 'VZL' ? 0 : item?.origin === 'COP' ? 1 : 2);
        return [...items].sort((a, b) => originRank(a) - originRank(b));
      }
      return items;
    },
    hasVenezuelaItems() {
      return this.lineItems.some((item) => item?.origin === 'VZL');
    },
    hasColombiaItems() {
      return this.lineItems.some((item) => item?.origin === 'COP');
    },
    pickedCount() {
      return this.pickingItems.filter((i) => i.status === "picked").length;
    },
    pendingPickingItems() {
      return this.pickingItems.filter((i) => i.status !== "picked");
    },
    pickingProgress() {
      if (!this.pickingItems.length) return 0;
      return Math.round((this.pickedCount / this.pickingItems.length) * 100);
    },
    sortedPickingItems() {
      return [...this.pickingItems].sort((a, b) => {
        if (a.status === 'picked' && b.status !== 'picked') return 1;
        if (a.status !== 'picked' && b.status === 'picked') return -1;
        return 0;
      });
    },
    isOrderPrepared() {
      if (!this.order) return false;
      const history = Array.isArray(this.order.status_history) ? this.order.status_history : [];
      if (history.length) {
        return history[history.length - 1]?.status === 'PREPARADO';
      }
      return this.order.fulfillment_status === 'PREPARADO';
    },
    isOrderDispatched() {
      if (!this.order) return false;
      const history = Array.isArray(this.order.status_history) ? this.order.status_history : [];
      if (history.length) {
        const last = history[history.length - 1]?.status;
        return last === 'DESPACHADO' || last === 'ENTREGADO';
      }
      return this.order.fulfillment_status === 'DESPACHADO' || this.order.fulfillment_status === 'ENTREGADO';
    },
    hasWaybill() {
      if (!this.order) return false;
      const pj = this.order.picking_json;
      return !!(pj && typeof pj === 'object' && (pj.id || (pj.data && pj.data.id)));
    },
    waybillId() {
      if (!this.hasWaybill) return null;
      const pj = this.order.picking_json;
      return pj.id || pj.data.id;
    },
    isVeOrder() {
      return (
        this.$route.name === 'Shopify Vzla Order Detail' ||
        this.$route.query.source === 'shopify-ve'
      );
    },
    pickingApi() {
      return this.isVeOrder ? shopifyVeService : shopifyService;
    },
  },
  mounted() {
    this.fetchOrder();
  },
  beforeUnmount() {
    if (this.scanDebounceTimer) {
      clearTimeout(this.scanDebounceTimer);
    }
  },
  methods: {
    itemPrice(item) {
      if (item == null) return 0;
      if (item.price != null) return parseFloat(item.price) || 0;
      if (item.unit_price != null) return parseFloat(item.unit_price) || 0;
      return 0;
    },
    itemTotal(item) {
      if (item == null) return 0;
      if (item.line_total != null) return parseFloat(item.line_total) || 0;
      if (item.line_subtotal != null) return parseFloat(item.line_subtotal) || 0;
      return this.itemPrice(item) * (parseInt(item.quantity) || 1);
    },
    itemPriceCop(item) {
      const rate = parseFloat(this.order?.usd_exchange_rate);
      if (!rate) return '—';
      return this.formatMoney(this.itemPrice(item) * rate, 'COP');
    },
    formatNumber(value) {
      if (value == null) return '—';
      return new Intl.NumberFormat('es-CO', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(parseFloat(value) || 0);
    },
    formatExcelCurrency(value) {
      const n = parseFloat(value) || 0;
      return n.toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },
    escapeExcelCell(raw) {
      if (raw == null || raw === '') return '';
      return String(raw).replace(/\t/g, ' ').replace(/\r?\n/g, ' ').trim();
    },
    async copyVeItemsForExcel() {
      const rows = this.lineItems.filter((item) => item?.origin === 'VZL');
      if (!rows.length) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin ítems VZL',
          text: 'No hay productos de Venezuela en este pedido para copiar.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const rate = parseFloat(this.order?.usd_exchange_rate);
      if (!rate) {
        await Swal.fire({
          icon: 'info',
          title: 'Sin tasa de cambio',
          text: 'Este pedido no tiene la tasa USD almacenada; resincronízalo para calcular el precio en pesos.',
          confirmButtonText: 'Aceptar',
        });
        return;
      }

      const header = [
        'Producto', 'Descripcion', 'Lote', 'Cantidad', 'Unidad',
        'Precio', 'Descuento', 'Cod IVA', 'Remisión', 'Precio Ref',
      ].join('\t');

      const lines = rows.map((item) => {
        const ref = item.codigo_prod || item.sku || '';
        const lote = [item.size_name, item.color_name].filter(Boolean).join(' ')
          || (item.variant_title || '');
        const qty = parseFloat(item.quantity) || 0;
        const priceCop = this.itemPrice(item) * rate;

        return [
          this.escapeExcelCell(ref),
          '',
          this.escapeExcelCell(lote),
          String(qty),
          'UN',
          this.formatExcelCurrency(priceCop),
          '',
          '19',
          '',
          '',
        ].join('\t');
      });

      const tsv = [header, ...lines].join('\n');

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(tsv);
        } else {
          const ta = document.createElement('textarea');
          ta.value = tsv;
          ta.style.position = 'fixed';
          ta.style.left = '-9999px';
          document.body.appendChild(ta);
          ta.focus();
          ta.select();
          document.execCommand('copy');
          document.body.removeChild(ta);
        }

        await Swal.fire({
          icon: 'success',
          title: 'Ítems copiados',
          text: `${rows.length} ítem(s) VZL copiados al portapapeles. Crea la factura en Kubapp Venezuela y pega los registros copiados (Ctrl+V).`,
          confirmButtonText: 'Entendido',
        });
      } catch (e) {
        await Swal.fire({
          icon: 'error',
          title: 'No se pudo copiar',
          text: 'El navegador bloqueó el portapapeles o no hay permisos HTTPS.',
          confirmButtonText: 'Aceptar',
        });
      }
    },
    async syncOrderToKubapp() {
      if (!this.order?.id || this.isSyncingKubapp) return;

      const confirm = await Swal.fire({
        icon: 'question',
        title: 'Sincronizar con Kubapp Colombia',
        text: 'Se enviará la factura de venta de este pedido directamente a Kubapp Colombia. ¿Continuar?',
        showCancelButton: true,
        confirmButtonText: 'Sincronizar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;

      this.isSyncingKubapp = true;
      try {
        const response = await shopifyVeService.syncOrderToKubapp(this.order.id);
        const data = response?.data || {};

        if (!data.success) {
          throw new Error(data.message || 'No se pudo sincronizar con Kubapp.');
        }

        if (data.order && this.order) {
          this.order.kubapp_invoiced_at = data.order.kubapp_invoiced_at;
        }

        await Swal.fire({
          icon: 'success',
          title: 'Factura sincronizada',
          text: data.message || 'La factura de venta fue registrada en Kubapp.',
          confirmButtonText: 'Aceptar',
        });
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error al sincronizar',
          text: error?.response?.data?.message || error.message || 'No se pudo sincronizar con Kubapp.',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        this.isSyncingKubapp = false;
      }
    },
    async toggleInvoiced() {
      if (!this.order?.id || this.isMarkingInvoiced) return;

      const isInvoiced = !!this.order.kubapp_invoiced_at;
      const confirm = await Swal.fire({
        icon: 'question',
        title: isInvoiced ? 'Quitar marca de facturado' : 'Marcar como facturado',
        text: isInvoiced
          ? 'Se quitará la marca de facturación de este pedido. ¿Continuar?'
          : 'Se marcará este pedido como facturado. ¿Continuar?',
        showCancelButton: true,
        confirmButtonText: isInvoiced ? 'Quitar marca' : 'Marcar',
        cancelButtonText: 'Cancelar',
      });
      if (!confirm.isConfirmed) return;

      this.isMarkingInvoiced = true;
      try {
        const response = await shopifyVeService.markOrderInvoiced(this.order.id, !isInvoiced);
        const data = response?.data || {};

        if (!data.success) {
          throw new Error(data.message || 'No se pudo actualizar la orden.');
        }

        if (data.order) {
          this.order.kubapp_invoiced_at = data.order.kubapp_invoiced_at;
        }
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || error.message || 'No se pudo actualizar la orden.',
          confirmButtonText: 'Aceptar',
        });
      } finally {
        this.isMarkingInvoiced = false;
      }
    },
    orderLabel(order) {
      if (order?.source === "shopify" || order?.source === "shopify-ve") {
        return order.name || `#${order.shopify_order_id}`;
      }
      return `#${order.id}`;
    },
    onScanInput() {
      if (this.scanDebounceTimer) {
        clearTimeout(this.scanDebounceTimer);
      }
      const val = this.scanValue.trim();
      if (!val) return;
      this.scanDebounceTimer = setTimeout(() => {
        this.handleScan();
      }, 300);
    },
    async fetchOrder() {
      const source = this.$route.query.source || 'shopify';
      const id = this.$route.query.id;
      if (!id) {
        this.order = null;
        return;
      }
      this.isLoading = true;
      try {
        const response = await shopifyService.getOrder(source, id);
        this.order = response?.data?.data ?? null;
        if (this.order) {
          await this.fetchPicking(this.order.id);
        }
      } catch (error) {
        console.error("Error al cargar el pedido:", error);
        this.order = null;
      } finally {
        this.isLoading = false;
      }
    },
    async fetchPicking(orderId) {
      try {
        const response = await this.pickingApi.getPicking(orderId);
        this.pickingItems = response?.data?.data ?? [];
        if (!this.pickingItems.length) {
          const initResponse = await this.pickingApi.initPicking(orderId);
          this.pickingItems = initResponse?.data?.data ?? [];
        }
      } catch {
        this.pickingItems = [];
      }
    },
    async startPicking() {
      if (!this.order) return;
      try {
        const response = await this.pickingApi.initPicking(this.order.id);
        this.pickingItems = response?.data?.data ?? [];
      } catch (error) {
        console.error("Error al iniciar picking:", error);
      }
      this.showPickingModal = true;
      this.scanMessage = "";
      this.scanMessageType = "";
      this.$nextTick(() => {
        this.focusScanInput();
      });
    },
    focusScanInput() {
      if (this.$refs.scanInput) {
        this.$refs.scanInput.focus();
      }
    },
    async handleScan() {
      const sku = this.scanValue.trim();
      if (!sku || this.isScanning) return;

      this.isScanning = true;
      this.scanMessage = "";

      try {
        const response = await this.pickingApi.scanPicking(this.order.id, sku);
        const data = response?.data;

        if (data?.success) {
          this.scanMessage = data.message || "Producto marcado como preparado.";
          this.scanMessageType = "success";

          const updated = data.data;
          if (updated) {
            const idx = this.pickingItems.findIndex((i) => i.id === updated.id);
            if (idx >= 0) {
              this.pickingItems[idx] = updated;
            }
          }
        } else {
          this.scanMessage = data?.message || "Error al procesar el SKU.";
          this.scanMessageType = "error";
        }
      } catch (error) {
        const msg = error?.response?.data?.message;
        this.scanMessage = msg || "SKU no encontrado o ya preparado.";
        this.scanMessageType = "error";
      } finally {
        this.isScanning = false;
        this.scanValue = "";
        this.$nextTick(() => {
          this.focusScanInput();
        });
      }
    },
    async completePicking() {
      if (!this.order) return;
      this.isCompletingPicking = true;
      try {
        const response = this.isVeOrder
          ? await shopifyVeService.updateOrderStatus(this.order.id, 'PREPARADO')
          : await shopifyService.updateOrderStatus(this.order.source || 'shopify', this.order.id, 'PREPARADO');
        const data = response?.data;
        if (data?.status_history) {
          this.order.status_history = data.status_history;
        }
        if (data?.order?.fulfillment_status) {
          this.order.fulfillment_status = data.order.fulfillment_status;
        }
        Swal.fire({
          icon: 'success',
          title: 'Estado actualizado',
          text: 'El estado del pedido cambió a PREPARADO.',
          timer: 2500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al actualizar estado de la orden:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar el estado del pedido.',
        });
      } finally {
        this.isCompletingPicking = false;
        this.closePickingModal();
      }
    },
    async markAsDispatched() {
      if (!this.order) return;
      const result = await Swal.fire({
        icon: 'question',
        title: '¿Marcar como despachado?',
        text: 'El pedido se marcará directamente como DESPACHADO sin generar guía de envío.',
        showCancelButton: true,
        confirmButtonText: 'Sí, despachar',
        cancelButtonText: 'Cancelar',
        confirmButtonColor: '#f59e0b',
      });
      if (!result.isConfirmed) return;
      this.isMarkingDispatched = true;
      try {
        const response = this.isVeOrder
          ? await shopifyVeService.updateOrderStatus(this.order.id, 'DESPACHADO')
          : await shopifyService.updateOrderStatus(
              this.order.source || 'shopify',
              this.order.id,
              'DESPACHADO'
            );
        const data = response?.data;
        if (data?.status_history) {
          this.order.status_history = data.status_history;
        }
        if (data?.order?.fulfillment_status) {
          this.order.fulfillment_status = data.order.fulfillment_status;
        }
        Swal.fire({
          icon: 'success',
          title: 'Despachado',
          text: 'El pedido se marcó como DESPACHADO correctamente.',
          timer: 2500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al marcar como despachado:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo actualizar el estado del pedido.',
        });
      } finally {
        this.isMarkingDispatched = false;
      }
    },
    async togglePickingItem(item) {
      if (item.toggling) return;
      const idx = this.pickingItems.findIndex((i) => i.id === item.id);
      if (idx < 0) return;
      this.pickingItems[idx].toggling = true;
      try {
        const response = await this.pickingApi.togglePickingItem(item.id);
        const updated = response?.data?.data;
        if (updated) {
          this.pickingItems[idx] = { ...this.pickingItems[idx], ...updated, toggling: false };
        }
      } catch (error) {
        console.error('Error al toggle picking item:', error);
        this.pickingItems[idx].toggling = false;
      }
    },
    async markAllPicked() {
      if (this.isMarkingAllPicked) return;
      const pending = this.pickingItems.filter((i) => i.status !== "picked" && !i.toggling);
      if (!pending.length) return;
      this.isMarkingAllPicked = true;
      try {
        for (const item of pending) {
          const idx = this.pickingItems.findIndex((i) => i.id === item.id);
          if (idx < 0) continue;
          this.pickingItems[idx].toggling = true;
          try {
            const response = await this.pickingApi.togglePickingItem(item.id);
            const updated = response?.data?.data;
            if (updated) {
              this.pickingItems[idx] = { ...this.pickingItems[idx], ...updated, toggling: false };
            } else {
              this.pickingItems[idx].toggling = false;
            }
          } catch (error) {
            console.error('Error al marcar item como preparado:', error);
            this.pickingItems[idx].toggling = false;
          }
        }
      } finally {
        this.isMarkingAllPicked = false;
      }
    },
    closePickingModal() {
      this.showPickingModal = false;
      this.scanValue = "";
      this.scanMessage = "";
      this.scanMessageType = "";
    },
    getVariantTitle(pickingItem) {
      const match = this.lineItems.find((li) => {
        if (pickingItem.line_item_id && li.id) {
          return parseInt(li.id) === parseInt(pickingItem.line_item_id);
        }
        if (pickingItem.variant_id && li.variant_id) {
          return parseInt(li.variant_id) === parseInt(pickingItem.variant_id);
        }
        return false;
      });
      return match?.variant_title || '';
    },
    getItemPickingStatus(item) {
      const match = this.pickingItems.find((p) => {
        if (item.id && p.line_item_id) {
          return parseInt(p.line_item_id) === parseInt(item.id);
        }
        if (item.variant_id && p.variant_id) {
          return parseInt(p.variant_id) === parseInt(item.variant_id);
        }
        if (item.sku && p.sku) {
          return p.sku === item.sku;
        }
        return false;
      });
      return match ? match.status : "pending";
    },
    goBack() {
      this.$router.push({ name: "Shopify Ordenes" });
    },
    isRestrictedCity(cityName) {
      if (!cityName) return false;
      const norm = String(cityName)
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .trim()
        .replace(/\s+/g, " ");
      const restricted = [
        "CUCUTA",
        "LOS PATIOS",
        "PATIOS",
        "VILLA DEL ROSARIO",
        "VILLA ROSARIO",
      ];
      return restricted.some((r) => norm === r || norm.includes(r));
    },
    initShippingForm() {
      const addr = this.order?.shipping_address || {};
      this.shippingForm = {
        address: (addr.address1 || "").trim(),
        city: (addr.city || "").trim(),
        province: (addr.province || addr.province_code || "").trim(),
        zip: (addr.zip || "").toString().trim(),
        phone: (addr.phone || "").toString().trim(),
        company: (addr.company || "").toString().trim(),
      };

      // Canonicalizar departamento y ciudad contra ciudades.json para preseleccionar los selects
      const deptMatch = this.shippingDepartments.find(
        (d) => normalizeCityName(d) === normalizeCityName(this.shippingForm.province)
      );
      if (deptMatch) {
        this.shippingForm.province = deptMatch;
        const cityMatch = this.shippingCities.find(
          (c) => normalizeCityName(c) === normalizeCityName(this.shippingForm.city)
        );
        if (cityMatch) {
          this.shippingForm.city = cityMatch;
        }
      }
    },
    onShippingProvinceChange() {
      const city = this.shippingForm.city.trim();
      if (city && this.shippingCities.length
        && !this.shippingCities.some((c) => normalizeCityName(c) === normalizeCityName(city))) {
        this.shippingForm.city = "";
      }
    },
    shippingFormAddress() {
      const original = this.order?.shipping_address || {};
      return {
        ...original,
        address1: this.shippingForm.address.trim(),
        city: this.shippingForm.city.trim(),
        province: this.shippingForm.province.trim(),
        zip: this.shippingForm.zip.trim(),
        phone: this.shippingForm.phone.trim(),
        company: this.shippingForm.company.trim(),
      };
    },
    async recalculateShipping() {
      if (!this.shippingForm.address.trim() || !this.shippingForm.city.trim()) {
        await Swal.fire({
          icon: "warning",
          title: "Datos incompletos",
          text: "Ingresa al menos la dirección y la ciudad para recalcular el envío.",
          confirmButtonText: "Entendido",
        });
        return;
      }
      this.shippingOptions = [];
      this.selectedShippingOption = null;
      this.hasCalculatedShipping = false;
      await this.calculateShipping();
    },
    async openShippingModal() {
      const addr = this.order?.shipping_address || {};
      const city = (addr.city || "").trim();
      if (this.isRestrictedCity(city)) {
        await Swal.fire({
          icon: "warning",
          title: "Envío no permitido",
          html: `Este pedido es de <b>${city}</b>.<br>No se permite generar guía de envío para Cúcuta, Los Patios o Villa del Rosario.`,
          confirmButtonText: "Entendido",
        });
        return;
      }
      this.showShippingModal = true;
      this.shippingOptions = [];
      this.shippingError = "";
      this.selectedShippingOption = null;
      this.hasCalculatedShipping = false;
      this.initShippingForm();
      await this.calculateShipping();
    },
    closeShippingModal() {
      this.showShippingModal = false;
      this.shippingOptions = [];
      this.shippingError = "";
      this.selectedShippingOption = null;
      this.hasCalculatedShipping = false;
    },
    buildPackageDetail() {
      const items = this.lineItems;
      const description = items.map((item) => item.title || item.name || "producto").join(", ");
      const totalPrice = items.reduce((sum, item) => sum + this.itemTotal(item), 0);
      return [
        {
          type: "Box",
          package_number: "",
          description: description || "producto",
          weight: 1,
          quantity: 1,
          price: totalPrice,
          dimensions: {
            length: 1,
            width: 1,
            height: 1,
          },
        },
      ];
    },
    getRecipientCity(addrOverride = null) {
      const addr = addrOverride || this.order?.shipping_address;
      if (!addr) return "";
      const city = (addr.city || "").trim();
      const zip = (addr.zip || "").toString().trim();
      let result = buscarCodigoDane(city, addr.province, addr.province_code);
      if (!result && zip) result = zip;
      console.log('[getRecipientCity] addr:', addr);
      console.log('[getRecipientCity] city:', city, '| zip:', zip, '| resultado:', result);
      return result;
    },
    async calculateShipping() {
      if (!this.order) return;
      this.isCalculatingShipping = true;
      this.shippingError = "";
      try {
        const recipientCity = this.getRecipientCity(this.shippingFormAddress());
        const orderLabel = this.orderLabel(this.order);
        const payload = {
          shopify_order_id: this.order.id,
          sender_city: "54001000",
          recipient_city: recipientCity,
          package_detail: this.buildPackageDetail(),
          charge_shipping_to_customer: this.chargeShippingToCustomer,
          payment_method: this.shippingPaymentMethod,
          package_type: "Paquetes",
          notes: orderLabel,
          external_id: `shp-${orderLabel}`,
        };
        const response = await shopifyService.calculateShipping(payload);
        const data = response?.data?.data ?? response?.data ?? {};
        this.shippingOptions = Array.isArray(data) ? data : (data.options || data.results || (Object.keys(data).length ? [data] : []));
      } catch (error) {
        this.shippingError = error?.response?.data?.message || "Error al calcular el envío.";
        this.shippingOptions = [];
      } finally {
        this.isCalculatingShipping = false;
        this.hasCalculatedShipping = true;
      }
    },
    async generateTicket() {
      if (!this.order || this.selectedShippingOption === null) return;

      const addr = this.shippingFormAddress();
      const province = (addr.province || addr.province_code || '').trim();
      const selectedOpt = this.shippingOptions[this.selectedShippingOption] || {};

      // Validación: si la provincia es Bogotá, D.C., pedir confirmación para revisar la dirección
      if (/bogot[aá]\s*,?\s*d\.?c\.?/i.test(province)) {
        const confirm = await Swal.fire({
          icon: 'warning',
          title: 'Revisar dirección de envío',
          html: `La provincia aparece como <b>${province}</b>.<br>Verifica que la dirección de envío sea correcta antes de continuar.`,
          showCancelButton: true,
          confirmButtonText: 'Continuar',
          cancelButtonText: 'Cancelar',
          reverseButtons: true,
        });
        if (!confirm.isConfirmed) {
          return;
        }
      }

      this.isGeneratingWaybill = true;
      try {
        const customer = this.order.customer || {};
        const recipientCity = this.getRecipientCity(addr);
        const stateCode = recipientCity
          ? recipientCity.substring(0, 2)
          : (addr.province_code || addr.province || '').substring(0, 2);
        const payload = {
          shopify_order_id: this.order.id,
          sender: {
            address: {
              street: "AV 5 # 5 - 63, SEXTO PISO, BARRIO LATINO",
              city: "54001000",
              neighborhood: "",
              state: "54",
              country: "CO",
            },
          },
          receiver: {
            name: this.order.customer_name || [addr.first_name, addr.last_name].filter(Boolean).join(' ') || 'Cliente',
            address: {
              street: addr.address1 || 'sin dirección',
              city: recipientCity,
              neighborhood: "",
              state: stateCode || "54",
              country: addr.country_code || "CO",
            },
            email: this.order.email || customer.email || '',
            document_type: "CC",
            document_number: addr.company || "10000000",
            phone: addr.phone || customer.phone || '',
          },
          package_type: "Paquetes",
          package_details: this.buildPackageDetail(),
          payment_method: this.shippingPaymentMethod,
          status: "Aceptado",
          charge_shipping_to_customer: this.chargeShippingToCustomer,
          notes: this.orderLabel(this.order),
          external_id: `shp-${this.orderLabel(this.order)}`,
          carrier_id: selectedOpt.carrier_id || undefined,
          shipping_method: selectedOpt.carrier_id || undefined,
          shipping_cost: selectedOpt.price || selectedOpt.total || 0,
        };
        const response = await shopifyService.generateWaybill(payload);
        console.log('[generateWaybill] response.data:', response?.data);
        const data = response?.data?.data ?? response?.data ?? {};
        console.log('[generateWaybill] data extraído:', data);
        const waybillId = data.id;
        console.log('[generateWaybill] waybillId:', waybillId);
        if (waybillId) {
          this.order.picking_json = data;
          Swal.fire({
            icon: 'success',
            title: 'Guía generada',
            text: 'La guía de envío se generó correctamente.',
            timer: 2500,
            showConfirmButton: false,
          });
        } else {
          Swal.fire({
            icon: 'success',
            title: 'Guía generada',
            text: 'La guía de envío se generó correctamente, pero no se obtuvo el ID del rótulo.',
            timer: 2500,
            showConfirmButton: false,
          });
        }
        this.closeShippingModal();
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo generar la guía de envío.',
        });
      } finally {
        this.isGeneratingWaybill = false;
      }
    },
    async printWaybill() {
      if (!this.hasWaybill) return;
      this.isPrintingWaybill = true;
      try {
        const pdfResponse = await shopifyService.getWaybillPdf([this.waybillId]);
        console.log('[printWaybill] response.data:', pdfResponse?.data);
        const pdfData = pdfResponse?.data?.data ?? null;
        console.log('[printWaybill] pdfData (primeros 100 chars):', pdfData ? pdfData.substring(0, 100) : null);
        if (pdfData) {
          const pdfBlob = this.base64ToBlob(pdfData, 'application/pdf');
          const pdfUrl = URL.createObjectURL(pdfBlob);
          console.log('[printWaybill] abriendo PDF en nueva pestaña:', pdfUrl);
          window.open(pdfUrl, '_blank');
        } else {
          Swal.fire({
            icon: 'warning',
            title: 'Sin rótulo',
            text: 'No se recibió el PDF del rótulo.',
          });
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error?.response?.data?.message || 'No se pudo obtener el rótulo.',
        });
      } finally {
        this.isPrintingWaybill = false;
      }
    },
    base64ToBlob(base64, contentType = '') {
      const byteCharacters = atob(base64);
      const byteArrays = [];
      for (let offset = 0; offset < byteCharacters.length; offset += 512) {
        const slice = byteCharacters.slice(offset, offset + 512);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
      }
      return new Blob(byteArrays, { type: contentType });
    },
    formatMoney(value, currency = "COP") {
      if (value == null) return "—";
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: currency || "COP",
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(value);
    },
    formatDate(value) {
      if (!value) return "—";
      return new Date(value).toLocaleString("es-CO", {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
    openCustomerEditModal() {
      const customer = this.order?.customer || {};
      this.customerEditForm = {
        customer_name: this.order?.customer_name || "",
        email: this.order?.email || "",
        phone: customer.phone || "",
      };
      this.showCustomerEditModal = true;
    },
    closeCustomerEditModal() {
      this.showCustomerEditModal = false;
    },
    async saveCustomer() {
      if (!this.order) return;
      this.isSavingCustomer = true;
      try {
        const response = await shopifyService.updateCustomer(this.order.id, this.customerEditForm);
        const updated = response?.data?.data;
        if (updated) {
          this.order = {
            ...this.order,
            customer_name: updated.customer_name,
            email: updated.email,
            customer: updated.customer,
          };
        }
        this.showCustomerEditModal = false;
        Swal.fire({
          icon: 'success',
          title: 'Cliente actualizado',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al guardar cliente:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar el cliente.',
        });
      } finally {
        this.isSavingCustomer = false;
      }
    },
    openAddressEditModal() {
      const addr = this.order?.shipping_address || {};
      this.addressEditForm = {
        first_name: addr.first_name || "",
        last_name: addr.last_name || "",
        address1: addr.address1 || "",
        address2: addr.address2 || "",
        city: addr.city || "",
        province: addr.province || "",
        country: addr.country || "",
        zip: addr.zip || "",
        phone: addr.phone || "",
      };
      this.showAddressEditModal = true;
    },
    closeAddressEditModal() {
      this.showAddressEditModal = false;
    },
    async saveAddress() {
      if (!this.order) return;
      this.isSavingAddress = true;
      try {
        const response = await shopifyService.updateShippingAddress(this.order.id, this.addressEditForm);
        const updated = response?.data?.data;
        if (updated) {
          this.order = { ...this.order, shipping_address: updated };
        }
        this.showAddressEditModal = false;
        Swal.fire({
          icon: 'success',
          title: 'Dirección actualizada',
          timer: 1500,
          showConfirmButton: false,
        });
      } catch (error) {
        console.error('Error al guardar dirección:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar la dirección.',
        });
      } finally {
        this.isSavingAddress = false;
      }
    },
  },
};
</script>

<style scoped>
/* ---- Picking Packing Modal ---- */
.picking-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.picking-modal-box {
  background: #fff;
  border-radius: 16px;
  max-width: 480px;
  width: 90%;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}
.picking-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 24px;
  border-bottom: 1px solid #e9ecef;
}
.picking-modal-header h5 {
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}
.picking-modal-body {
  padding: 20px 24px;
  overflow-y: auto;
  flex: 1;
}
.location-info-row {
  margin-bottom: 10px;
  line-height: 1.5;
}
.location-info-row:last-child {
  margin-bottom: 0;
}
.picking-modal-footer {
  padding: 14px 24px;
  border-top: 1px solid #e9ecef;
}
.picking-scan-input-wrapper {
  display: flex;
  gap: 8px;
}
.picking-scan-input {
  flex: 1;
  font-size: 15px;
  border: 2px solid #d1d5db;
  border-radius: 8px;
  padding: 10px 14px;
  height: 44px;
  box-sizing: border-box;
}
.picking-scan-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
  outline: none;
}
.picking-scan-btn {
  border-radius: 8px;
  padding: 0 16px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.picking-scan-message {
  margin-top: 12px;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
}
.picking-scan-message.success {
  background: #d1fae5;
  color: #065f46;
}
.picking-scan-message.error {
  background: #fee2e2;
  color: #991b1b;
}
.picking-items-list {
  max-height: 460px;
  overflow-y: auto;
}
.picking-item-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  margin-bottom: 6px;
  background: #f9fafb;
  transition: background 0.2s;
}
.picking-item-row.picking-item-picked {
  background: #ecfdf5;
}
.shipping-option-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border-radius: 8px;
  margin-bottom: 6px;
  background: #f9fafb;
  cursor: pointer;
  border: 2px solid transparent;
  transition: all 0.2s;
}
.shipping-option-row:hover {
  background: #eff6ff;
}
.shipping-option-selected {
  border-color: #2563eb;
  background: #eff6ff;
}
</style>
